import React, { cloneElement } from 'react';
import { Section } from './ui/Section';
import { Wrench, Phone, Home, Hammer, Clock, ArrowRight, Layers, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
const services = [{
  icon: <Wrench className="h-8 w-8" data-id="element-136" />,
  title: 'Maintenance & Repairs',
  description: 'From leaky faucets to drywall patches, we handle the small fixes that keep your home running smoothly.',
  timeframe: '1-2 days typical turnaround',
  color: 'bg-blue-50 text-blue-700'
}, {
  icon: <Phone className="h-8 w-8" data-id="element-137" />,
  title: 'Service Calls',
  description: 'Something break unexpectedly? We offer quick diagnostic visits and immediate repairs for urgent issues.',
  timeframe: 'Same or next day response',
  color: 'bg-red-50 text-red-700'
}, {
  icon: <Home className="h-8 w-8" data-id="element-138" />,
  title: 'Remodels',
  description: 'Bathroom updates, kitchen refreshes, and room transformations. We specialize in high-impact renovation projects.',
  timeframe: '1-4 week project duration',
  color: 'bg-green-50 text-green-700'
}, {
  icon: <Hammer className="h-8 w-8" data-id="element-139" />,
  title: 'Handyman Services',
  description: 'TV mounting, furniture assembly, door adjustments, and honey-do lists. No job is too small.',
  timeframe: 'Hourly rates available',
  color: 'bg-orange-50 text-orange-700'
}, {
  icon: <Layers className="h-8 w-8" data-id="element-140" />,
  title: 'Flooring Installation',
  description: 'Expert installation of all flooring types including hardwood, laminate, vinyl, tile, and carpet. Professional subfloor prep included.',
  timeframe: '2-5 days typical project',
  color: 'bg-purple-50 text-purple-700'
}, {
  icon: <Building2 className="h-8 w-8" data-id="element-141" />,
  title: 'Commercial Cleaning',
  description: 'Professional cleaning services for offices, retail spaces, and commercial properties. We keep your business looking its best.',
  timeframe: 'Daily, weekly, or monthly',
  color: 'bg-teal-50 text-teal-700'
}];
export function Services() {
  const navigate = useNavigate();
  return <Section id="services" background="white" data-id="element-142">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-143">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2c2c2c] mb-4" data-id="element-144">
          Services Designed for Homeowners
        </h2>
        <p className="text-lg text-[#525252]" data-id="element-145">
          We focus on the jobs big contractors ignore. Professional, clean, and
          reliable service for your everyday home needs.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-146">
        {services.map((service, index) => <motion.div key={index} whileHover={{
        y: -5,
        transition: {
          duration: 0.2
        }
      }} className="group p-8 rounded-2xl bg-[#faf8f5] border border-gray-100 hover:shadow-xl hover:border-[#17a2b8]/20 transition-all duration-300 cursor-pointer" onClick={() => navigate('/services')} data-id="element-147">
            <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 ${service.color} bg-white shadow-sm`} data-id="element-148">
              {cloneElement(service.icon as React.ReactElement, {
            className: 'h-7 w-7'
          })}
            </div>

            <h3 className="text-2xl font-bold text-[#2c2c2c] mb-3 group-hover:text-[#17a2b8] transition-colors" data-id="element-149">
              {service.title}
            </h3>

            <p className="text-[#525252] mb-6 leading-relaxed" data-id="element-150">
              {service.description}
            </p>

            <div className="flex items-center justify-between" data-id="element-151">
              <div className="flex items-center gap-2 text-sm font-medium text-[#17a2b8] bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-152">
                <Clock className="h-4 w-4" data-id="element-153" />
                {service.timeframe}
              </div>

              <div className="flex items-center gap-1 text-sm font-semibold text-[#17a2b8] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-154">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-155" />
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-156">
        <p className="text-[#525252] mb-4" data-id="element-157">
          Not sure if we cover what you need?
        </p>
        <a href="#contact" className="inline-flex items-center font-semibold text-[#17a2b8] hover:text-[#138496] transition-colors" data-id="element-158">
          Ask us about your project <ArrowRight className="ml-1 h-4 w-4" data-id="element-159" />
        </a>
      </div>
    </Section>;
}